export { PerfectScrollbarComponent } from './perfect-scrollbar.component';
export { PerfectScrollbarDirective } from './perfect-scrollbar.directive';

export {
  Geometry,
  Position,

  PERFECT_SCROLLBAR_CONFIG,

  PerfectScrollbarConfig,
  PerfectScrollbarConfigInterface
} from './perfect-scrollbar.interfaces';

export { PerfectScrollbarModule } from './perfect-scrollbar.module';
